import React, { useState, useEffect } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// icon
import { AiOutlineEye } from 'react-icons/ai';
//components
import Button from 'components/backoffice/buttonCustom';
import Input from 'components/backoffice/customInput';
import WatchModal from 'components/backoffice/modals/WatchModal';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import SpinnerComponent from 'components/backoffice/SpinnerComponent';

const CategoryForm = ({
  isEditing,
  onSubmitForm,
  fileInputRef,
  defaultValues,
  onDelete,
  openModalDelete,
  setOpenModalDelete,
  validateName,
  setValidateName,
  loading
}) => {
  const { t } = useTranslation(['backoffice']);
  const [openModalImage, setOpenModalImage] = useState(false);

  const {
    formState: { errors },
    setValue,
    reset,
    control,
    handleSubmit,
    getValues,
    watch,
    clearErrors
  } = useForm();

  let item;
  const image = getValues('image');

  const watchItem = (item) => {
    setValue('image', item);
    setOpenModalImage(true);
  };


  const handleClearFile = () => {
    setValue('image', undefined);
    setValue('name', '');
    setValidateName('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    if (!isEditing)
      reset(defaultValues);
  }, [reset, defaultValues]);

  useEffect(() => {
    if (defaultValues) {
      if (isEditing) {
        setValue('image', null);
        if (defaultValues?.image) fetch(defaultValues?.image)
          .then((response) => response.blob())
          .then((blob) => {
            const name = defaultValues?.image.split('?')[0].split('/').pop()
            const file = new File([blob], name, { type: `image/${name.split('.')[1]}` });
            setValue('image', file);
          })
          .catch((error) => {
            console.error('Error al obtener la imagen:', error);
          });
      }
      else setValue('image', defaultValues?.image);
      setValue('name', defaultValues?.name);
    }
  }, [defaultValues])

  useEffect(() => {

    if (validateName) {
      setValue('name', getValues('name'), { shouldValidate: true });
    }

    if (!validateName || getValues('name') === '') {
      setValidateName('');
    }

  }, [validateName, setValue, getValues]);


  useEffect(() => {
    if (!validateName) {
      clearErrors('name');
    }
  }, [validateName, clearErrors]);



  if (isEditing) {
    item = typeof image === 'string' ? image : (image instanceof Blob || image instanceof File) ? URL.createObjectURL(image) : '';
  } else {
    item = image !== undefined ? URL.createObjectURL(image) : '';
  }

  return (
    <div className="mt-5">
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="name"
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                },
                validate: () => {
                  return validateName || true;
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Input
                  type="text"
                  label={t('categoryName')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('categoryName')}
                />
              )}
            />
            <div className="mt-1">
              {errors?.name && <small className="text-danger ">{errors.name.message}</small>}
            </div>
          </Col>
          <Col sm={12} md={12} lg={4} className="d-flex mt-4 mt-lg-0 mb-md-2 mb-lg-0">
            <div className="d-flex w-100">
              <div className='w-100'>
                <Controller
                  name="image"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: t('camporequerido'),
                    },
                  }}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Input
                        type="file"
                        dropFileMsg={t('dropFile')}
                        label={t('imagen')}
                        placeholder={t('selectImg')}
                        accept="image/*"
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        ref={fileInputRef}
                      />
                    );
                  }}
                />
              </div>
              <div className="d-flex ms-3 mx-sm-3 mx-0 align-bottom">
                <Button
                  color="terciary"
                  onClick={(e) => { e.preventDefault(); watchItem(getValues('image')); }}
                >
                  <AiOutlineEye color="white" />
                </Button>
              </div>
            </div>
            <div className="mt-1">
              {errors?.image && <small className="text-danger">{errors.image.message}</small>}
            </div>
          </Col>
        </Row>
      </Form>
      <div className="mt-4 d-flex justify-content-end gap-3">
        <Button
          color="primary"
          onClick={handleSubmit(onSubmitForm)}
          loading={loading}
        >
          {t('save')}
          <SpinnerComponent loading={loading} />
        </Button>

        {isEditing ?
          <Button
            color="secondary"
            onClick={() => setOpenModalDelete(true)}
            loading={loading}
          >
            {t('eliminar')}
          </Button> :
          <Button
            color="terciary"
            onClick={handleClearFile}
            loading={loading}
          >
            {t('clean')}
          </Button>}
      </div>
      <DeleteModalCustom
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        handleDelete={onDelete}
        deleteTitle={t('deleteblogcategory')}
        beforeTitle={t('edit', { title: defaultValues?.name })}
      />
      <WatchModal
        item={item}
        title={t('imagen')}
        show={openModalImage}
        setShow={setOpenModalImage}
        beforeTitle={t('edit', { title: defaultValues?.name })}
      />
    </div>
  );
};

PropTypes.CategoryForm = {
  isEditing: PropTypes.bool,
  onSubmitForm: PropTypes.func,
  fileInputRef: PropTypes.object,
  defaultValues: PropTypes.object,
  onDelete: PropTypes.func,
  openModalDelete: PropTypes.bool,
  setOpenModalDelete: PropTypes.func,
  validateName: PropTypes.bool,
  setValidateName: PropTypes.func,
  loading: PropTypes.bool
};


export default CategoryForm;